import React from 'react';
import { useState, useEffect } from "react";

import English from '/static/i18n/en.json';
import Bengali from '/static/i18n/bn.json';
import axios from "axios";

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import CardGrid from "../../components/card/CardGrid";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { useLanguage } from '../../components/language/LanguageContext'; // Import the custom hook
import FixedLengthText from "../../components/fixed_length";



const locale = navigator.language;

let lang;
if (locale === "en") {
  lang = English;
} else {
  lang = Bengali;
}


const imageStyle = {
  height: '250px', // Set the desired height for all images
  width: 'auto',   // Maintain the aspect ratio
  objectFit: 'cover', // Preserve aspect ratio while covering the container
};

const CardItem = ({ article, maxLength, children }) => {
  const { language } = useLanguage();
  // Check if imgpath contains 'youtube.com'
  const isYouTube = article.media_url.includes('youtube.com');
  

  // Extract the YouTube video ID from the imgpath (assuming it's a full URL)
  const getYouTubeVideoId = (url) => {
    const match = url.match(/[?&]v=([^&]+)/);
    return match ? match[1] : null;
  };

  const videoId = isYouTube ? getYouTubeVideoId(article.media_url) : null;

  return (
    <Col>
      <Card style={{ border: "1px solid #666464" }}>
        {isYouTube ? (
          // Embedded YouTube video
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '250px' }}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video"
            />
          </div>
        ) : (
          // Regular image
          <Card.Img variant="top" src={`${article.media_url}`} style={imageStyle} />
        )}
        <Card.Body style={{ backgroundColor: "black", color: "#fff" }}>
          {language === 'en' ? (
            <Card.Title>{article.title}</Card.Title>
          ) : (
            <Card.Title>{article.title}</Card.Title>
          )}
          <div style={{ height: "200px" }}>
            {language === 'en' ? (
              <FixedLengthText text={article.summary} maxLength={maxLength} />
            ) : (
              <FixedLengthText text={article.summary} maxLength={maxLength} />
            )}
          </div>

          {children}
        </Card.Body>
      </Card>
    </Col>
  );
};

const CardButtons = (props) => {
  return (
      <>
         <Button variant="primary" href={`${props.link}`} >Read</Button>
      </>
  );
}


const NewsPage = (props) => {

  const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("https://stemx365.org/api/v1/media/")
            .then((response) => {
                setNews(response.data);
                setLoading(false);
            })
            .catch((error) => console.error("Error fetching news:", error));
    }, []);

    return (
        <div style={{backgroundColor:"black"}}>
            <h1>Space News</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <CardGrid style={{ display: "flex" }}>
                <Row xs={1} md={4} className="g-4">
                    {
                        news ?
                        news.map((article, index) => <CardItem key={index} article={article} maxLength={300}><CardButtons link={article.link} /></CardItem>) : null
                    }
                </Row>
                </CardGrid>
            )}
        </div>
    );





  // const [state, setState] = useState({
  //   tournaments: []
  // });

  // useEffect(() => {
  //   let isMounted = true;
  //   let accessToken = "gdgdfghfhggytuyghj";

  //   const fetchData = async () => {
  //     try {
  //         await ApiService.getAllData().then((data) => {
  //           //console.log("data.tornament ....",data.tournament);
  //           if (isMounted) setState({ ...state, tournaments: data.tournament })
  //         }
  //         );
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // };
  // fetchData();



  //   return () => { isMounted = false };
  // }, []);


  // return (

  //   <div className="container news">
  //     <div class="heading-03"><h2>news</h2></div>
  //     <h3>Television and YouTube</h3>
  //     <Grid container spacing={2}>
  //       <Grid item xs={6}>
  //         <iframe width="100%" height="315" src="https://www.youtube.com/embed/B872C1yb1rU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <p><a href="https://www.youtube.com/watch?v=B872C1yb1rU" target="_blank">Sep 11, 2021&nbsp;দেশের ধনেপাতা চাষ হবে মহাকাশে! | Space Plant | BD Coriander leaves | NASA | Somoy TV</a></p>
  //       </Grid>
  //     </Grid>

  //     <h3>News Articles</h3>
  //     <Grid container spacing={2}>
  //       <Grid item xs={6}>
  //         <img width="100%" height="315" src="https://www.tbsnews.net/features/pursuit/enigma-systems-robotics-team-who-sent-amar-shonar-bangla-space-334441" />
  //       </Grid>
  //       <Grid item xs={6}>
  //       <p>
  //         <a href="https://www.tbsnews.net/features/pursuit/enigma-systems-robotics-team-who-sent-amar-shonar-bangla-space-334441" target="_blank">November 25, 2021&nbsp;Enigma Systems: The robotics team who sent ‘Amar Shonar Bangla’ to space</a></p>
  //       </Grid>
  //     </Grid>

  //     <div style={{ textAlign: 'left' }}>
       
  //       <h3>News Articles</h3>
        
  //       <p>
  //         <a href="https://digibanglatech.news/news/local/science/65307/?fbclid=IwAR2XYRt1FEH-BGV9YgeeFzsBQTyaI_3WWxGPAXYtWwLe29TCVJ2xiYv6j8s" target="_blank">December 11, 2021&nbsp;নাসা’র স্পেস অ্যাপ্স চ্যালেঞ্জে বিশ্বসেরা বাংলাদেশের ‘মহাকাশ’</a></p>


  //       <p>
  //         <a href="https://biz-usa.org/mizanul-haq-chowhdury-a/" target="_blank">April 26, 2021&nbsp;Bangladeshi born architect and system administrator of MIT</a></p>
  //       <p>
  //         <a href="https://www.newsbangla24.com/news/156322/In-the-wealth-of-Bangladesh-the-sprouts-are-in-space?fbclid=IwAR3TfXsyq0bDL2tOe5-1H9LP0wTIyZsefaYiUJAxxnCjetKjxRqFt3VP0kU" target="_blank">September 9, 2021&nbsp;বাংলাদেশের ‌ধনে গজাল মহাকাশে</a></p>

  //       <p>
  //         <a href="https://www.dhakapost.com/country/60273?fbclid=IwAR2b8it1baW2uBui30Z5M9NE3YxirsuUmURtK5uVMOoWDIZxC0RYOAhcoDM" target="_blank">September 8, 2021&nbsp;মহাকাশে বাংলাদেশের ধনিয়া বীজ</a></p>
  //       <p>
  //         <a href="https://www.dailynayadiganta.com/plant-animal/607190/%E0%A6%AE%E0%A6%B9%E0%A6%BE%E0%A6%95%E0%A6%BE%E0%A6%B6%E0%A7%87-%E0%A6%A8%E0%A6%BE%E0%A6%AE-%E0%A6%B2%E0%A7%87%E0%A6%96%E0%A6%BE%E0%A6%B2%E0%A7%8B-%E0%A6%AC%E0%A6%BE%E0%A6%82%E0%A6%B2%E0%A6%BE%E0%A6%A6%E0%A7%87%E0%A6%B6%E0%A7%87%E0%A6%B0-%E0%A6%A7%E0%A6%A8%E0%A6%BF%E0%A7%9F%E0%A6%BE-%E0%A6%AC%E0%A7%80%E0%A6%9C?fbclid=IwAR1awUIj3q4iLS-sDYQTAFm7LwYPdEHJVbZN9dUxrtEPt1I2y2dH5nDYCC4" target="_blank">September 8, 2021&nbsp;মহাকাশে নাম লেখালো বাংলাদেশের ধনিয়া বীজ!</a></p>

  //       <h3>Seminar and Speech</h3>

  //       <p>
  //         <a href="https://www.facebook.com/nib.gov.bd/posts/2902017496795586" target="_blank">Oct 28, 2021&nbsp;National Institute of Biotechnology</a></p>
  //       <p>
  //         <a href="https://www.facebook.com/messenger_media/?thread_id=100000645018978&amp;attachment_id=401387078043838&amp;message_id=mid.%24cAAAAAAg66kGB9dC4tl7xItjv0V_W" target="_blank">Oct 28, 2021&nbsp;Kibo AHiS Press Release, National Institute of Biotechnology</a></p>
  //       <p>
  //         <a href="https://events.vtools.ieee.org/m/245335" target="_blank">Oct 31, 2020&nbsp;MOTIVATIONAL TECHNICAL LECTURE PROGRAM ON "TEACHING INTERACTIVE STEM EDUCATION IN DEVELOPING NATIONS USING AN INTERNATIONAL SPACE STATION PLATFORM" BY MIZANUL HOQ CHOWDHURY</a></p>
  //     </div>
  //   </div>

  // );
};

export default NewsPage;
//ReactDOM.render(<LabPage />, document.getElementById("render-labs"));